/* eslint-disable react/jsx-props-no-spreading */
// reason: https://ant.design/components/icon
import React from 'react';

import Icon, {
  ThunderboltFilled,
  HomeFilled,
  SafetyCertificateFilled,
  ToolFilled,
  SettingFilled,
  ShoppingFilled,
  SignalFilled,
} from '@ant-design/icons';
import { ReactComponent as exportTR } from '@assets/svg/export-tr.svg';
import { ReactComponent as FinanceFilledSvg } from '@assets/svg/finance-filled.svg';

import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

type IconMapType = Record<string, any>;
interface IconLibraryProps extends Partial<CustomIconComponentProps> {
  name?: string;
}
const ANTD_ICON_MAP: IconMapType = {
  ThunderboltFilled,
  HomeFilled,
  SafetyCertificateFilled,
  ToolFilled,
  SettingFilled,
  ShoppingFilled,
  SignalFilled,
  FinanceFilled: (props: IconLibraryProps) => (
    <Icon component={FinanceFilledSvg} {...props} />
  ),
  ExportTR: (props: IconLibraryProps) => (
    <Icon component={exportTR} {...props} />
  ),
};

export const iconOptions = Object.keys(ANTD_ICON_MAP);

function IconLibrary({ name = '', ...props }: IconLibraryProps) {
  let TargetIcon = ThunderboltFilled;
  if (name && ANTD_ICON_MAP[name]) {
    TargetIcon = ANTD_ICON_MAP[name];
  }

  return <TargetIcon {...props} />;
}

export default IconLibrary;
